import React, { InputHTMLAttributes } from 'react';
import {
  MultiAutocompleteTokenControl,
  useMultiAutocomplete,
  MultiSelectMenu,
  ClearableFooter,
  DefaultItem,
  UseMultiAutocompleteProps,
  RenderMenuItem,
} from '@adsk/alloy-react-dropdown';

export type DropdownMultiSelectProps<T extends DefaultItem> =
  UseMultiAutocompleteProps<T> & {
    onClickClearSelectedOptions?: () => void;
    itemRenderer?: RenderMenuItem<T>;
    inputProps?: InputHTMLAttributes<HTMLInputElement>;
  };

export const DropdownMultiSelect = <T extends DefaultItem>({
  onClickClearSelectedOptions,
  itemRenderer,
  inputProps,
  ...DropdownProps
}: DropdownMultiSelectProps<T>) => {
  const {
    isOpen,
    menuItems,
    getComboboxProps,
    getInputProps,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getItemProps,
    getSelectedItemProps,
    addSelectedItem,
    removeSelectedItem,
    selectedItems,
    highlightedIndex,
    targetProps,
    openMenu,
  } = useMultiAutocomplete<T>(DropdownProps);

  return (
    <div>
      <MultiAutocompleteTokenControl
        getInputProps={() => getInputProps(inputProps)}
        getComboboxProps={getComboboxProps}
        getSelectedItemProps={getSelectedItemProps}
        removeSelectedItem={removeSelectedItem}
        isOpen={isOpen}
        selectedItems={selectedItems}
        getToggleButtonProps={getToggleButtonProps}
        getLabelProps={getLabelProps}
        targetProps={targetProps}
        openMenu={openMenu}
      />
      <MultiSelectMenu
        isOpen={isOpen}
        menuItems={menuItems}
        targetProps={targetProps}
        highlightedIndex={highlightedIndex}
        selectedItems={selectedItems}
        getMenuProps={getMenuProps}
        getItemProps={getItemProps}
        addSelectedItem={addSelectedItem}
        removeSelectedItem={removeSelectedItem}
        renderMenuItem={itemRenderer}
        renderFooter={() =>
          onClickClearSelectedOptions ? (
            <ClearableFooter
              setSelectedItems={() => onClickClearSelectedOptions()}
            />
          ) : null
        }
      />
    </div>
  );
};
